import Vue from "vue";

Vue.directive("intersect", {
  bind(el, binding) {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          binding.value(entry)
        }
      });
    }, options)

    observer.observe(el)
    el._observer = observer
  },
  unbind(el) {
    if (el._observer) {
      el._observer.disconnect()
      delete el._observer
    }
  },
})
